"use client";
import { jsxs as x, Fragment as I, jsx as a } from "react/jsx-runtime";
import b from "clsx";
import w from "next/image";
import j from "next/link";
import { memo as B, isValidElement as E } from "react";
import '../../../assets/InfoBox.css';const A = "_info_box_1pp2a_1", D = "_inner_1pp2a_20", F = "_icon_1pp2a_28", T = "_right_1pp2a_31", V = "_icon_right_box_1pp2a_34", k = "_orange_1pp2a_48", q = "_violet_1pp2a_60", z = "_small_1pp2a_73", G = "__text_1pp2a_81", H = "__icon_left_1pp2a_85", J = "_text_1pp2a_85", K = "_image_1pp2a_102", L = "_large_1pp2a_109", M = "__disabled_1pp2a_144", O = "__loading_1pp2a_148", P = "__icon_right_1pp2a_152", Q = "_left_1pp2a_152", S = "_rotation_1pp2a_1", t = {
  info_box: A,
  inner: D,
  icon: F,
  right: T,
  icon_right_box: V,
  orange: k,
  violet: q,
  small: z,
  _text: G,
  _icon_left: H,
  text: J,
  image: K,
  large: L,
  _disabled: M,
  _loading: O,
  _icon_right: P,
  left: Q,
  rotation: S
}, U = B(
  ({
    text: n,
    iconLeft: o,
    iconRight: e,
    color: u = "orange",
    size: v = "small",
    loading: s,
    disabled: d,
    className: N,
    href: g,
    scroll: y = !0,
    onClick: i,
    ...l
  }) => {
    const f = (_) => {
      var c;
      if (s || d) {
        _.preventDefault();
        return;
      }
      const r = _.currentTarget.getAttribute("data-event");
      r && ((c = window == null ? void 0 : window.dataLayer) == null || c.push({
        event: r
      })), i == null || i(
        _
      );
    }, h = (_, r, c) => E(_) ? _ : typeof _ == "string" ? /* @__PURE__ */ a(
      "div",
      {
        className: b("material-icons", t.icon, r),
        "data-icon": c ? "progress_activity" : _
      }
    ) : /* @__PURE__ */ a(
      w,
      {
        className: t.image,
        src: _,
        height: 24,
        width: 24,
        alt: "icon"
      }
    ), p = /* @__PURE__ */ x(I, { children: [
      /* @__PURE__ */ x("span", { className: t.inner, children: [
        o && h(o, t.left, !e && s),
        n && /* @__PURE__ */ a("span", { className: t.text, children: n })
      ] }),
      e && /* @__PURE__ */ a("span", { className: t.icon_right_box, children: h(e, t.right, s) })
    ] }), m = b(
      t.info_box,
      t[u],
      t[v],
      {
        [t._loading]: s,
        [t._disabled]: d,
        [t._text]: n && o || n && e,
        [t._icon_left]: o,
        [t._icon_right]: e
      },
      N
    );
    return g ? /* @__PURE__ */ a(
      j,
      {
        href: g,
        scroll: y,
        onClick: f,
        className: m,
        ...l,
        children: p
      }
    ) : i ? /* @__PURE__ */ a("button", { onClick: f, className: m, ...l, children: p }) : /* @__PURE__ */ a("div", { className: m, ...l, children: p });
  }
);
U.displayName = "InfoBox";
export {
  U as InfoBox
};
